module.exports = __webpack_public_path__ + "img/itunes.png";